import {
  IAuthErrorResponse,
  IAuthResponse,
  IAuthSuccessResponse,
} from "@/struct/ILogin/ILogin";

export function isAuthSuccess(
  response: IAuthResponse,
): response is IAuthSuccessResponse {
  return "access_token" in response;
}

export function isAuthError(
  response: IAuthResponse,
): response is IAuthErrorResponse {
  return "error" in response;
}
